<template>
 <div :class="isShowMe?'cancelOrder':'cancelOrder hide'">
     <div :class="isShowMe?'detailList-bg':'detailList-bg hide'"></div>
     
     <div class="detailList">
			<div class="dl-top">
				<div class="dl-title fl">申请撤销订单</div>
				<div class="dl-close fr"><img @click="closeWindow" src="../assets/close.png" ></div>
			</div>
    
     <div class="main">
        <el-row align="middle" type="flex" class="mb20"> 
              <el-col :span="3"><div class="grid-content bg-purple">{{payText}}：</div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple"><el-input-number label="要求支付" :disabled="false" :min="0" :max="Price" v-model="PayLevelBal" name="PayLevelBal" size="small" controls-position="right" :controls="false"></el-input-number></div></el-col>
              <el-col :span="16"><div class="grid-content bg-purple">最多{{Price}}元</div></el-col>
        </el-row>
        <el-row  align="middle" type="flex" class="mb20"> 
              <el-col :span="3"><div class="grid-content bg-purple">{{compensation}}：</div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple"><el-input-number label="愿意赔偿" :disabled="false" :min="0" :max="Ensure" v-model="RepEnsureBal" name="RepEnsureBal" size="small" controls-position="right" :controls="false"></el-input-number></div></el-col>
              <el-col :span="16"><div class="grid-content bg-purple">最多{{Ensure}}元</div></el-col>
        </el-row>
         <el-row  align="top" type="flex" class="mb20"> 
              <el-col :span="3"><div class="grid-content bg-purple">撤销原因：</div></el-col>
              <el-col :span="21"><div class="grid-content bg-purple"><el-input size="small"  type="textarea" rows="3" v-model="Comment" placeholder="请输入撤销原因"></el-input></div></el-col>
        </el-row>
		  <p class="prompts">请先与对方协商处理。若无法协商，请上传相关证据截图，在申请撤销一个小时后申请客服介入</p>
     </div>
    <div class="dl-footer">
         <span class="fr"><el-button type="primary" size="medium" @click="cancelOrder">提交</el-button></span>
    </div>
		</div>
  </div>
</template>

<script>
export default {
  name: 'cancelOrder',
  props:{
    isShow:Boolean,
    Price:Number,
    Ensure:Number,
    IsPub:Number,
    SerialNo:String,
    Stamp:Number
  },
  data () {
    return {
      payText:'要求支付',
      compensation:'愿意赔偿',
      PayLevelBal:0,
      RepEnsureBal:0,
      Comment:'',
      isShowMe:this.isShow
    }
  },
  computed:{
     loading(){
       return this.$store.getters.loadingPara;
     }
  },
  watch: {
    isShow(val) {
      this.isShowMe = val;
    },
    isShowMe(val){
      if(val){
        if(this.IsPub==1){
          this.payText="愿意支付";
          this.compensation="要求赔偿"
        }else{
          this.payText="要求支付";
          this.compensation="愿意赔偿"
        }
      }else
        this.$emit("on-close",val);
    }
  },
  methods: {
    closeWindow(){
			this.isShowMe=false;
    },
    cancelOrder(){
      var msg="请输入您的支付密码";
      this.$prompt(msg, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputPlaceholder:'请输入您的支付密码',
      inputType:'password',
      inputPattern: /\S/,
      inputErrorMessage: '请输入您的支付密码'
      }).then(({ value }) => {
          if(this.Comment==""){
            this.$message({ message: '请输入撤销原因', type: 'warning'});
          }else{
            const self = this;
            var data= self.common.GetlocalStorage("UnLockUserData");
            var obj=JSON.parse(data);
            var userId=obj.UserID;
            var paypass=self.http.get_pwd_hash(value,obj.uid);
            const loading = this.$loading(this.loading);
            self.http.ajaxGet("LevelOrderCancel?UserID="+userId+"&SerialNo="+this.SerialNo+"&PayLevelBal="+this.PayLevelBal+"&RepEnsureBal="+this.RepEnsureBal+"&Comment="+this.Comment+"&PayPass="+paypass+"&Stamp="+this.Stamp,function(res){
                loading.close();
                if(res.ReturnCode == 1){
                  //申请撤销成功的回调
                  self.$emit("on-success");
                  self.closeWindow();
                  self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
                }else{
                  self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
                }	
              },function(err){
                loading.close();
                self.$alert(err, '错误', {confirmButtonText: '确定'});
            })
          }
      }).catch(() => {  });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .detailList-bg{position:fixed;width:100%;height:100%;bottom:0;background:#000;filter:alpha(opacity=50); -moz-opacity:0.5; opacity: 0.5; margin:0; padding:0; z-index:999; }
	.detailList{width:740px;height:460px;position: fixed; top:50%; left:50%; margin-left:-370px; margin-top:-230px;  z-index:1000; background: #fff; }
	.detailList .dl-top{background: #f0f0f0; height:60px; line-height: 60px;}
	.detailList .dl-title{ font-size:20px; color:#444; margin-left:45px;}
	.detailList .dl-close{ margin-right:25px; margin-top:8px;}
	.detailList .dl-close img{ cursor: pointer;}
  .detailList .dl-footer{height:60px; line-height:60px; font-size:16px; color:#444; background: #eee; position:absolute; bottom:0; width:680px; padding:0 30px;}
  .detailList .main{ padding:0 30px; font-size:16px; color:#444;}
  .mb20{margin-bottom:20px;}
  ul{overflow: hidden; height: auto; color: #444; line-height: 1;}
  li{padding: 1.3rem 1.5rem 0 1.5rem;background-color: #fff;margin-top: 1rem;box-sizing: border-box;}
  li p{	padding-bottom: 1.3rem; overflow: hidden;}
  li .lable{float: left;display: block;width: 25%;line-height: 1.5;}
  .weChatText{float: left;width:72%;display:block;border: none;font-size: 1.3rem;padding: 0;margin: 0;line-height: 1.3;}
  .main{ margin-top: 50px;}
  .prompts{color:#E65050;}
</style>



// WEBPACK FOOTER //
// src/components/cancelOrder.vue